/** Saves `blob` to the browser's downloads as `fileName`. */
export function saveSnapshot(blob: Blob, fileName: string): void {
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = fileName;
    link.click();
    // Revoked on a later task, once the click has started the download from it.
    setTimeout(() => URL.revokeObjectURL(url), 0);
}
